export function processSpeakingQuestionHtml(html) {
  if (!html) return html;
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  
  const correctAnswerIndicators = doc.querySelectorAll('.correct-answer-indicator');
  correctAnswerIndicators.forEach(indicator => indicator.remove());
  
  doc.querySelectorAll('*').forEach(element => {
    if (element.innerHTML) {
      element.innerHTML = element.innerHTML
        .replace(/(&lt;(\d+)&gt;)/g, '')
        .replace(/(<(\d+)>)/g, '');
    }
  });
  
  const walker = doc.createTreeWalker(
    doc.body,
    NodeFilter.SHOW_TEXT,
    null
  );
  
  let node;
  while (node = walker.nextNode()) {
    if (node.textContent) {
      node.textContent = node.textContent.replace(/<(\d+)>/g, '');
    }
  }
  
  return doc.body.innerHTML;
}
